define(["github:ded/reqwest@1.1.5/reqwest.js"], function(main) {
  return main;
});